import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Button } from "@jti/ui/components/Button";
import { useConfig } from "@jti/ui/providers/useConfig";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import styles from "./AddProductButton.module.scss";
export const PromoButton = ({ type }) => {
    const { __ } = useTranslations();
    const [authWithPDPBackUrl, setAuthWithPDPBackUrl] = useState("");
    const config = useConfig();
    useEffect(() => {
        const currentPathName = window.location.pathname;
        setAuthWithPDPBackUrl(`${config.AUTH_PAGE_URL}#/login?returnUrl=${currentPathName}`);
    }, [config.AUTH_PAGE_URL]);
    const buttonContent = {
        ["LOGIN" /* PROMO_BUTTON_TYPE.LOGIN */]: {
            href: authWithPDPBackUrl,
            text: __("com.product.login_button_label"),
        },
        ["SIMILAR_PRODUCTS" /* PROMO_BUTTON_TYPE.SIMILAR_PRODUCTS */]: {
            href: config.SHOP_URL,
            text: __("com.product.similar_products_button_label"),
        },
    };
    const { href, text } = buttonContent[type] ?? {};
    if (!href || !text)
        return null;
    return (_jsx("div", { className: styles.addProductButtonWrapper, "data-testid": "promo-button", children: _jsx(Button, { href: href, nativeBehaviour: true, children: _jsx("span", { className: "aem-button__text", children: text }) }) }));
};
//# sourceMappingURL=PromoButton.js.map